import 'moment/locale/pt-br';
import Vue from 'vue';
import App from './App.vue';
import store from '@/store';
import Watchers from '@/store/watchers';
import router from '@/router';
import Zendesk from '@dansmaculotte/vue-zendesk';
import Push from '@/services/NotificationPush';
import VueGtm from 'vue-gtm';

const { VUE_APP_GTM_ID, VUE_APP_ZENDESK_KEY } = process.env;

Vue.use(VueGtm, {
  id: VUE_APP_GTM_ID,
  vueRouter: router,
});

Vue.use(Zendesk, {
  key: VUE_APP_ZENDESK_KEY,
});

Vue.config.productionTip = false;

Watchers(store);

new Vue({
  store,
  router,
  render: h => h(App),
}).$mount('#app');

Push.Permission.request();
